import React from 'react';
import ReadOnlyDashboard from './ReadOnlyDashboard';

const LandingPage: React.FC = () => {
  return <ReadOnlyDashboard />;
};

export default LandingPage;

